import React, { useState } from "react";
import styles from "./TestimonialForm.module.css";
import axios from 'axios';


const TestimonialForm = () => {
const [testimonial, setTestimonial] = useState({ name: '', message: '' });

  const handleChange = (e) => {
    setTestimonial({ ...testimonial, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/testimonials`, {
        name: testimonial.name,
        message: testimonial.message,
      });

      alert(
       '✅ Thank you! Your testimonial has been sent for review.'
      );
      setTestimonial({ name: '', message: '' });
    } catch (err) {
      alert('Submission failed. Please try again.');
    }
  };

  return (
    <div className={styles.formContainer}>
      <h6 className={styles.title}>Share Your Testimonial</h6>
<form onSubmit={handleSubmit}>
              <div className="mb-2">
                <input
                  type="text"
                  name="name"
                  className="form-control form-control-sm"
                  placeholder={'Your Name'}
                  required
                  value={testimonial.name}
                  onChange={handleChange}
                />
              </div>
              <div className="mb-2">
                <textarea
                  name="message"
                  className="form-control form-control-sm"
                  rows="2"
                  placeholder={ 'Share your experience...'}
                  required
                  value={testimonial.message}
                  onChange={handleChange}
                ></textarea>
              </div>
              <button type="submit" className="btn btn-outline-dark btn-sm">
                {'Submit'}
              </button>
            </form>
    </div>
  );
};

export default TestimonialForm;
